import React from "react";
import { Link } from "react-router-dom";
import "../components/App.css";
import { Container } from "@mui/material";

const UserDashboard = () => {
  return (
    <Container>
      <div className="redirect-container">
        <div className="redirect-box">
          <h1>Welcome to Bevogtet</h1>
          <h5>Your one & only reliable Care Partner</h5>
          <Link to="/user/raise-claim">Raise your cover claim now</Link>
        </div>
      </div>
    </Container>
  );
};

export default UserDashboard;
